/**
 * Created by mykurisu on 2017/10/25.
 */
import React from 'react'
import '../../css/wkCommon.css'

class Item extends React.Component {
    render() {
        return (
            <div className="wk-item__container">
                <div className="wk-container__content">
                    <div className="wk-content__mid_block"></div>
                    <div className="wk-content__mid_block" style={{top: '18px'}}></div>
                    <div className="wk-content__horizon_block"></div>
                    <div className="wk-content__mid_block" style={{height: '10px', top: '54px'}}></div>
                </div>
            </div>
        )
    }
}


class WKSkeletonScreen extends React.Component {
    static defaultProps = {
        num: 1,
    };

    constructor() {
        super();
        this.state = {
            list: null
        }
    }

    componentDidMount() {
        let list = new Array(this.props.num).fill(null)
        this.setState({
            list: list
        })
    }

    render() {
        return (
            <div className="wk-skeleton__list">
                {this.state.list &&
                    this.state.list.map((item, index) => <Item key={index} />)
                }
            </div>
        )
    }
}

export default WKSkeletonScreen


// WEBPACK FOOTER //
// ./src/components/wk/WKSkeletonScreen.js